define('webshopAttributesFieldsPickerView',[
  'module',
  'marionette',
  'underscore',
  'events',
  'modalsAlertView',
  'entities/webshop/attribute_matching',
  'template!webshopAttributesFieldsPickerView'
], function (
  Module,
  Marionette,
  _,
  Events,
  AlertView,
  MatchingApi,
  Tpl
) {
  'use strict';

  var PAGE_SIZE = 50;

  // Window: supplier customfields to match onto an attribute (a field matched elsewhere moves to
  // this attribute). options: key, meta {suppliers}, onChanged().
  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'webshop-attributes-fields-picker-view',

    ui: {
      search: 'input.search',
      supplier: 'select.supplier',
      unmatched: 'input.unmatched',
      list: '.list',
      pager: '.pager',
      selectedCount: '.selected-count'
    },

    events: {
      'input @ui.search': 'onFilterChange',
      'change @ui.supplier': 'onFilterChange',
      'change @ui.unmatched': 'onFilterChange',
      'change input.check': 'onCheck',
      'click .apply': 'onApply',
      'click .prev': 'onPrev',
      'click .next': 'onNext'
    },

    initialize: function () {
      Events.push(this);
      this.first = 0;
      this.total = 0;
      this.items = [];
      this.checked = {};
    },

    onDestroy: function () {
      Events.pop(this);
    },

    serializeData: function () {
      return {
        keyName: MatchingApi.name(this.options.key),
        suppliers: this.options.meta.suppliers || []
      };
    },

    onShow: function () {
      // Start from the attribute's own name: most supplier fields are named alike.
      this.ui.search.val(this.options.key.code);
      this.fetch();
    },

    fetch: function () {
      var request = MatchingApi.supplierFields({
        search: this.ui.search.val(),
        supplier: this.ui.supplier.val(),
        unmatched: this.ui.unmatched.is(':checked'),
        first: this.first,
        pageSize: PAGE_SIZE
      });
      this.request = request;
      this.ui.list.addClass('am-loading');
      request.done(_.bind(function (page) {
        if (this.isDestroyed || request !== this.request)
          return;
        this.total = page.total;
        this.items = page.items;
        this.renderList();
      }, this)).fail(function (message) {
        AlertView.prototype.open('', message);
      }).always(_.bind(function () {
        if (!this.isDestroyed && request === this.request)
          this.ui.list.removeClass('am-loading');
      }, this));
    },

    renderList: function () {
      var keyId = this.options.key.id;
      var html = _.map(this.items, function (f) {
        var here = f.keyId === keyId;
        return '<label class="field ' + (here ? 'here' : '') + '" data-id="' + f.customFieldId + '">' +
          '<input type="checkbox" class="check" ' + (here ? 'checked disabled' : (this.checked[f.customFieldId] ? 'checked' : '')) + '/>' +
          '<span class="supplier">' + _.escape(f.supplierCode) + '</span>' +
          '<span class="code">' + _.escape(f.code) + '</span>' +
          '<span class="field-name">' + _.escape(f.name || '') + '</span>' +
          '<span class="count">' + f.valueCount + '</span>' +
          '<span class="matched">' + (f.keyCode ? '→ ' + _.escape(f.keyCode) : '') + '</span>' +
          '</label>';
      }, this).join('');
      this.ui.list.html(html || '<div class="empty">' + _.i18n('attributeMatching.noField', null, 'No supplier field') + '</div>');

      var last = Math.min(this.first + PAGE_SIZE, this.total);
      this.ui.pager.html(
        '<span class="prev ' + (this.first > 0 ? '' : 'off') + '"><i class="fa fa-chevron-left"></i></span>' +
        '<span>' + (this.total ? this.first + 1 : 0) + '–' + last + ' / ' + this.total + '</span>' +
        '<span class="next ' + (last < this.total ? '' : 'off') + '"><i class="fa fa-chevron-right"></i></span>');
    },

    onCheck: function (e) {
      var id = parseInt($(e.currentTarget).closest('.field').data('id'), 10);
      if ($(e.currentTarget).is(':checked'))
        this.checked[id] = true;
      else
        delete this.checked[id];
      this.ui.selectedCount.text(_.keys(this.checked).length);
    },

    onApply: function () {
      var ids = _.map(_.keys(this.checked), function (id) { return parseInt(id, 10); });
      if (!ids.length)
        return;
      MatchingApi.matchFields(ids, this.options.key.id).done(_.bind(function () {
        this.checked = {};
        this.ui.selectedCount.text(0);
        this.fetch();
        if (this.options.onChanged)
          this.options.onChanged();
      }, this)).fail(function (message) {
        AlertView.prototype.open('', message);
      });
    },

    onFilterChange: function () {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(_.bind(function () {
        this.first = 0;
        this.fetch();
      }, this), 300);
    },

    onPrev: function (e) {
      if ($(e.currentTarget).hasClass('off'))
        return;
      this.first = Math.max(0, this.first - PAGE_SIZE);
      this.fetch();
    },

    onNext: function (e) {
      if ($(e.currentTarget).hasClass('off'))
        return;
      this.first += PAGE_SIZE;
      this.fetch();
    },

    // Static methods
    open: function (data) {
      require([
        'windows',
        'webshopAttributesFieldsPickerView'
      ], function (Windows, View) {
        Windows.open({
          view: function () {
            return new View(data);
          },
          modal: true,
          width: 900,
          height: 620,
          minWidth: 600,
          minHeight: 400,
          title: _.i18n('attributeMatching.addFields', null, 'Match supplier fields') + ' : ' + MatchingApi.name(data.key)
        });
      });
    }
  });
});

